import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { useStateValue } from '../../state'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'

const ResetOrgModal = ({orgId, show, toggle}) => {
  const [currentState, dispatch] = useStateValue()


  const resetNameAndDomain = async () => {
    try {
      await client.get(endpoints.resetOrg({ orgId: orgId }))
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Success"
            content="Successfully reset the name and URL for this organization."
            scheme={Cinnamon.Crisp.SCHEME_BLUE}
            icon={<i className="far fa-thumbs-up fa-3x" />}
          />
        ),
      })
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
      toggle(false)
    } catch (err) {
      console.log(err)
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Error"
            content="There was an error resetting this organization."
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
      })
    }
  }

  return (
    <Modal show={show} onHide={() => toggle(!show)}>
      <Modal.Header closeButton>
        <Modal.Title>Reset Org Name and Domain</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure that you want to reset the name and domain that are currently associated with this organization?
      </Modal.Body>
      <Modal.Footer>
        <div
          className="btn btn-success btn-myed btn-success-myed"
          onClick={() => resetNameAndDomain()}
        >
          <div className="far fa-undo fa-fw mr-2" /> Reset
        </div>
      </Modal.Footer>
    </Modal>
  )
}

ResetOrgModal.propTypes = {
  orgId: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default ResetOrgModal
